import type { CraftData, CraftNodeValue } from "../runtime/types/core";

export function findComponentByType(
  data: CraftData,
  componentType: string,
): { nodeId: string; node: CraftNodeValue | "" } {
  for (const [nodeId, node] of Object.entries(data)) {
    if (
      node === componentType ||
      (typeof node === "object" && node.type?.resolvedName === componentType)
    ) {
      return { nodeId, node };
    }
  }
  return { nodeId: "", node: "" };
}
